import { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus, X } from "lucide-react";

// CATEGORY RULES — categories picked from his own list (clicking, not typing): "we won't use these" recommends every
// complete part in it; "always keep" never recommends one. Each add or take-off is its own change, with Undo.
export function CategoryRules({ rules = [], categories = [], kinds = {}, save }) {
  const [cat, setCat] = useState("");
  const [kind, setKind] = useState("wont_use");
  const [busy, setBusy] = useState(false);
  const name = (id) => categories.find((c) => c.id === id)?.name || "A category no longer on the list";
  const free = categories.filter((c) => !rules.some((r) => r.category_id === c.id));
  const put = async (next) => { setBusy(true); const ok = await save({ categories: next }); setBusy(false); if (ok) setCat(""); };
  return (
    <div data-testid="sales-rule-categories" className="rounded-xl border border-slate-200 bg-white p-3 space-y-2">
      <div className="font-bold text-slate-900">Category rules</div>
      {!rules.length && <p data-testid="sales-rule-categories-none" className="text-xs text-slate-500">None yet.</p>}
      {rules.map((r) => (
        <div key={r.category_id} data-testid={`sales-rule-cat-${r.category_id}`} className="flex items-center gap-2 text-sm">
          <span className="flex-1 min-w-0"><b>{name(r.category_id)}</b> — {kinds[r.kind]}</span>
          <button type="button" data-testid={`sales-rule-cat-remove-${r.category_id}`} disabled={busy}
            onClick={() => put(rules.filter((x) => x.category_id !== r.category_id))}
            className="inline-flex items-center gap-1 h-11 px-3 rounded-lg border-2 border-slate-300 bg-white text-sm font-bold hover:bg-slate-50 disabled:opacity-40">
            <X className="w-4 h-4" />Take off</button>
        </div>
      ))}
      <div className="flex flex-wrap items-center gap-2 pt-1">
        <Select value={cat} onValueChange={setCat}>
          <SelectTrigger data-testid="sales-rule-cat-pick" className="h-11 w-56"><SelectValue placeholder="Pick a category" /></SelectTrigger>
          <SelectContent>{free.map((c) => <SelectItem key={c.id} value={c.id} data-testid={`sales-rule-cat-option-${c.id}`}>{c.name}</SelectItem>)}</SelectContent>
        </Select>
        <Select value={kind} onValueChange={setKind}>
          <SelectTrigger data-testid="sales-rule-cat-kind" className="h-11 w-[20rem]"><SelectValue /></SelectTrigger>
          <SelectContent>{Object.entries(kinds).map(([k, w]) => <SelectItem key={k} value={k} data-testid={`sales-rule-cat-kind-${k}`}>{w}</SelectItem>)}</SelectContent>
        </Select>
        <button type="button" data-testid="sales-rule-cat-add" disabled={busy || !cat}
          onClick={() => put([...rules, { category_id: cat, kind }])}
          className="inline-flex items-center gap-1.5 h-11 px-4 rounded-lg bg-[#1F1F1F] hover:bg-black text-white text-sm font-bold disabled:opacity-40">
          <Plus className="w-4 h-4" />Add the rule</button>
      </div>
    </div>
  );
}
